function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6EB",
  fillRule: "evenodd",
  d: "M35 14.105c0 8.035-7.256 13.848-9.561 15.643-4.695 3.675-4.78 6.24-4.78 10.685 0 1.624-.854 3.505-5.037 3.505-3.5 0-4.695-1.283-4.695-5.728 0-7.351 3.244-10.856 5.72-12.993 2.816-2.393 7.597-5.043 7.597-9.66 0-3.931-3.415-5.812-7.683-5.812-8.707 0-6.83 6.582-11.44 6.582C2.818 16.327 0 14.788 0 11.454 0 6.838 5.293 0 16.817 0 27.744 0 35 6.07 35 14.105zM22.28 56.418c0 3.505-2.902 6.582-6.573 6.582-3.67 0-6.488-3.077-6.488-6.582 0-3.59 2.903-6.582 6.488-6.582 3.586 0 6.573 2.992 6.573 6.582z"
});

var SvgQuestionMark = function SvgQuestionMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 63,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/questionMark.12908995.svg";
export { ForwardRef as ReactComponent };